import { ContentfulItem } from './ContentfulItem';

import type {
  ILinkedComponent,
  ITextWithImage,
} from 'types/generated/contentful';

type IBodySection = (ILinkedComponent | ITextWithImage)[];

interface ContentfulBodySectionProps {
  content: IBodySection | undefined;
}

/**
 * Recursively render contentful content from the content field of the page builder page.
 * This first Level just walks through the top level components. The ContentfulItem component
 * then renders the actual component and progresses through its children.
 */
export const ContentfulBodySection = (props: ContentfulBodySectionProps) => {
  const { content } = props;

  if (!content) return null;

  const contentItems = content!.map((item: any, index: number) => (
    <ContentfulItem key={`bodycontent-${index}`} {...item} />
  ));

  return <>{contentItems}</>;
};
